import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Surface } from './Surface';

/**
 * What a section shows when it has nothing in it.
 *
 * Treated as a real state rather than an afterthought. An empty Continue
 * Watching row is the first thing anyone sees on a fresh install, so it is
 * worth it saying something useful instead of leaving a blank shelf.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
}: {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly description: string;
  readonly action?: ReactNode;
  readonly compact?: boolean;
}) {
  return (
    <Surface
      material="sunken"
      radius="lg"
      className={compact ? 'px-6 py-8' : 'px-8 py-14'}
    >
      <div className="mx-auto flex max-w-sm flex-col items-center text-center">
        <span
          aria-hidden="true"
          className="mb-4 flex size-11 items-center justify-center rounded-[var(--radius-md)] bg-surface-2 text-text-3"
        >
          <Icon size={19} strokeWidth={1.8} />
        </span>
        <p className="text-[0.875rem] font-medium text-text-1">{title}</p>
        <p className="mt-1.5 text-[0.8125rem] leading-relaxed text-text-3">{description}</p>
        {action !== undefined && <div className="mt-5">{action}</div>}
      </div>
    </Surface>
  );
}
